const React = require('react')
const { useEffect, useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { UncontrolledTooltip } = require('reactstrap')
const { useFormatTimestampShort, useFormatBytes } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner, CopyButton } = require('@components')

const { TokenDropdown } = require('./tokenDropdown.statistics')
const { MultichainBalanceDropdown } = require('./multichainBalanceDropdown.statistics')

require('@styles/pages/address/statistics.address.css')

const AddressStatistics = props => {
    const { loading, data, onTabChange } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatTimestamp = useFormatTimestampShort()
    const formatBytes = useFormatBytes()

    const [items, setItems] = useState([{}, {}, {}])

    useEffect(() => {
        if (!data) return

        const multichainBalance = Object.entries(data.information.multichainBalance)
            .filter(([_, item]) => item.balance > 0 || item.tokens.length > 0)
            .map(([key, item]) => ({ name: key, ...item }))

        setItems([
            {
                title: 'Overview',
                content: (
                    <>
                        <div className='statistics-box-sub-title'>{network.data.token} Balance</div>
                        <div className='statistics-box-value-small'>
                            {network.data.networkIcon && (
                                <img src={network.data.networkIcon} width='20px' style={{ marginRight: '8px' }} />
                            )}
                            {(data.balance / 10 ** 18).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 18
                            })}
                            &nbsp;
                            {network.data.token}
                        </div>
                        <br />
                        {data.tokens.totalItems > 0 && (
                            <>
                                <div className='statistics-box-sub-title'>Token Holdings</div>
                                <div className='statistics-box-value-small'>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <div style={{ flex: 1 }}>
                                            <TokenDropdown data={data} onTabChange={onTabChange} />
                                        </div>
                                        <div
                                            id='token-holdings'
                                            className={`statistics-icon ${network.name}-text-color-after`}
                                            onClick={() => {
                                                const currentQuery = window.location.search
                                                history.push(`${currentQuery}#asset-tokens`)
                                                onTabChange('asset-tokens')
                                            }}
                                        >
                                            <i className='fas fa-wallet' style={{ fontSize: '16px' }} />
                                        </div>
                                        <UncontrolledTooltip placement='top' target='token-holdings'>
                                            View in Token Holdings
                                        </UncontrolledTooltip>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )
            },
            {
                title: 'More Info',
                content: (
                    <>
                        {data.type === 'EOA' ? (
                            <>
                                <div className='statistics-box-sub-title'>Transaction Sent</div>
                                <div className='statistics-box-value-small'>
                                    <span style={{ color: 'var(--grey-color)' }}>Latest:&nbsp;</span>
                                    {data.information.latestTransaction.hash ? (
                                        <span
                                            className={`${network.name}-text-color-after`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() =>
                                                history.push(
                                                    `/${network.name}/tx/${data.information.latestTransaction.hash}`
                                                )
                                            }
                                        >
                                            {formatTimestamp(data.information.latestTransaction.blockTimestamp)}
                                            <i
                                                className='fas fa-up-right-from-square'
                                                style={{ marginLeft: '4px', fontSize: '12px' }}
                                            />
                                        </span>
                                    ) : (
                                        <span>N/A</span>
                                    )}
                                    &nbsp;&nbsp;
                                    <span style={{ color: 'var(--grey-color)' }}>First:&nbsp;</span>
                                    {data.information.firstTransaction.hash ? (
                                        <span
                                            className={`${network.name}-text-color-after`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() =>
                                                history.push(
                                                    `/${network.name}/tx/${data.information.firstTransaction.hash}`
                                                )
                                            }
                                        >
                                            {formatTimestamp(data.information.firstTransaction.blockTimestamp)}
                                            <i
                                                className='fas fa-up-right-from-square'
                                                style={{ marginLeft: '4px', fontSize: '12px' }}
                                            />
                                        </span>
                                    ) : (
                                        <span>N/A</span>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='statistics-box-sub-title'>Contract Creator</div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div
                                        className={`statistics-box-value-small ${network.name}-text-color cursor-pointer`}
                                        onClick={() =>
                                            history.push(
                                                `/${network.name}/address/${data.information.createTransactionHash.from}`
                                            )
                                        }
                                    >
                                        {formatBytes(data.information.createTransactionHash.from, 30, 7, 6)}
                                    </div>
                                    <CopyButton
                                        id={`copy-contract-creator-${data.information.createTransactionHash.from}`}
                                        data={data.information.createTransactionHash.from}
                                        text={'Copy address'}
                                    />
                                    &nbsp;at txn&nbsp;
                                    <div
                                        className={`statistics-box-value-small ${network.name}-text-color cursor-pointer`}
                                        onClick={() =>
                                            history.push(
                                                `/${network.name}/tx/${data.information.createTransactionHash.hash}`
                                            )
                                        }
                                    >
                                        {formatBytes(data.information.createTransactionHash.hash, 30, 10, 0)}
                                    </div>
                                </div>
                                <br />
                                {data.information.token.tokenType && (
                                    <>
                                        <div className='statistics-box-sub-title'>Token Tracker</div>
                                        <div
                                            className={`statistics-box-value-small ${network.name}-text-color cursor-pointer`}
                                            onClick={() => history.push(`/${network.name}/token/${address}`)}
                                        >
                                            {data.information.token.tokenName} ({data.information.token.tokenSymbol})
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </>
                )
            },
            {
                title: "VBchain's Multichain Info",
                content:
                    multichainBalance.length > 0 ? (
                        <MultichainBalanceDropdown multichainBalance={multichainBalance} />
                    ) : (
                        <>No address found</>
                    )
            }
        ])
    }, [data])

    return (
        <div className='statistics-boxes'>
            {items.map((item, index) => (
                <div key={index} className='statistics-box'>
                    {loading ? (
                        <div className='d-flex justify-content-center align-items-center' style={{ height: '210px' }}>
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <>
                            <div className='statistics-box-title'>{item.title}</div>
                            <br />
                            {item.content}
                        </>
                    )}
                </div>
            ))}
        </div>
    )
}

module.exports = { AddressStatistics }
